<template>
	<PrimaryButton :color="Color.Green" @click.stop="store">
		<i class="fa-solid fa-plus mr-2"/>
		{{ trans('general.create') }}
	</PrimaryButton>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {ref, type Ref, defineProps} from 'vue'
import {type InertiaForm, useForm} from '@inertiajs/vue3'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	returnUrl:string,
	returnLabel:string,
	certifiableId:number,
	certifiableType:string,
}>()

const working:Ref<boolean> = ref(false)
const form:InertiaForm<{returnLabel:string, returnUrl:string, type:string, id:number}> = useForm<{returnLabel:string, returnUrl:string, type:string, id:number}>({
	returnLabel: props.returnLabel,
	returnUrl: props.returnUrl,
	type: props.certifiableType,
	id: props.certifiableId,
})

function store():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.inserting'))
		form.post(route('certificates.store'), {
			onSuccess: () => {
				showSuccess(trans('general.inserted'))
			},
			onError: showValidationErrors,
			onFinish: () => {
				working.value = false
			},
		})
	}
}
</script>